import axios from 'axios';
const api = axios.create();
export const fetchSchools = api.get('/school')